import React from 'react';
import { Link } from 'react-router-dom';

const PricingVisibilityBar: React.FC = () => {
  return (
    <section className="py-12 bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600">
      <div className="container mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
          {/* Pricing Message */}
          <div className="text-center lg:text-left">
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-2">
              All 23 AI Tools. One Plan. £19/month.
            </h3>
            <p className="text-lg text-blue-100">
              No contracts. Cancel anytime. 7-day free trial included.
            </p>
          </div>

          {/* Value Props */}
          <div className="flex flex-wrap justify-center lg:justify-end gap-6 text-white">
            <div className="flex items-center gap-2">
              <svg className="w-6 h-6 text-yellow-300" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span className="font-semibold">Save 70% on software costs</span>
            </div>
            <div className="flex items-center gap-2">
              <svg className="w-6 h-6 text-yellow-300" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span className="font-semibold">Replace 10+ subscriptions</span>
            </div>
            <Link
              to="/pricing"
              className="inline-flex items-center justify-center px-6 py-3 text-base font-semibold text-blue-600 bg-white rounded-lg hover:bg-blue-50 transition-colors shadow-lg hover:shadow-xl"
            >
              View Pricing
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingVisibilityBar;
